export const LANGUAGE_STORAGE_KEY = 'lastKnownLanguage'
export const THEME_STORAGE_KEY = 'lastKnownTheme'
export const PROCESS_STORAGE_KEY = 'processes'